import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import ScrollToTop from "../../components/Hooks/ScrollToTop";
import Chart from "./Chart";
import styles from "./Insights.module.css";
import { FaAngleLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const PersonalInsights = () => {
	const data = [
		{ name: "Facebook", value: 50, fill: "#3b599d" },
		{ name: "Instagram", value: 80, fill: "#dc2743" },
		{ name: "Twitter", value: 70, fill: "#00acee" },
		{ name: "WhatsApp", value: 60, fill: "#25D366" },
	];

	const [activeInsight, setActiveInsight] = useState('Persona');
	// "Persona" ,"Influence","PersonaViews","Likes"

	const navigate = useNavigate();

	const [isMobile, setIsMobile] = useState(window.innerWidth < 431);
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 431);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);


	const PersonaData = [
		{ day: 'Mon', value: 80000 },
		{ day: 'Tue', value: 30000 },
		{ day: 'Wed', value: 90000 },
		{ day: 'Thu', value: 150000 },
		{ day: 'Fri', value: 90000 },
		{ day: 'Sat', value: 40000 },
		{ day: 'Sun', value: 150000 },
	];

	const InfluenceData = [
		{ day: 'Mon', value: 30000 },
		{ day: 'Tue', value: 90000 },
		{ day: 'Wed', value: 150000 },
		{ day: 'Thu', value: 60000 },
		{ day: 'Fri', value: 80000 },
		{ day: 'Sat', value: 30000 },
		{ day: 'Sun', value: 150000 },
	];

	const [chartData, setChartData] = useState(PersonaData)

	useEffect(() => {
		if (activeInsight === "Persona") {
			setChartData(PersonaData)
		} else if (activeInsight === "Influence") {
			setChartData(InfluenceData);
		}
	}, [activeInsight])
	return (

		<div className="App">
			<div className="MainContainer">
				<ScrollToTop />
				<Header />
				<div className={`${styles.Container} ${styles.Insights}`}>

					{
						!isMobile && (
							<div className={styles.BackButton}>
								<button onClick={() => { navigate('/Home') }}>
									<FaAngleLeft />
								</button>
							</div>
						)
					}
					<div className={styles.InsightsContainer}>
						<div className={styles.InsightsTop}>
							<div className={styles.InsightsTopLeft}>
								<h1>Profile Analysis</h1>
								<h4>Take a deep look at how your account and content are performing</h4>
							</div>

							<div className={styles.InsightsTopRight}>
								<select>
									<option value="1">1</option>
									<option value="2">2</option>
									<option value="3">3</option>
									<option value="4">4</option>
									<option value="5">5</option>
									<option value="6">6</option>
									<option value="7">7</option>
									<option value="8">8</option>
									<option value="9">9</option>
									<option value="10">10</option>
								</select>
							</div>
						</div>

						<div className={styles.InsightsBottom}>
							<div className={styles.InsightsBoxContainer}>
								<div
									onClick={() => { setActiveInsight('Persona') }}
									className={`${styles.InsightsBox} ${activeInsight === "Persona" ? styles.active : ""}`}
								>
									<h1>120K</h1>
									<p>Persona reached</p>
								</div>
								<div
									onClick={() => { setActiveInsight('Influence') }}
									className={`${styles.InsightsBox} ${activeInsight === "Influence" ? styles.active : ""}`}
								>
									<h1>120K</h1>
									<p>Influence</p>
								</div>
								<div
									onClick={() => { setActiveInsight('PersonaViews') }}
									className={`${styles.InsightsBox} ${activeInsight === "PersonaViews" ? styles.active : ""}`}
								>
									<h1>120K</h1>
									<p>Persona Views</p>
								</div>
								<div
									// onClick={() => { setActiveInsight('Likes') }}
									onClick={() => { navigate('/PostVisit') }}
									className={`${styles.InsightsBox} ${activeInsight === "Likes" ? styles.active : ""}`}
								>
									<h1>120K</h1>
									<p>Total Likes</p>
								</div>
							</div>

							{
								(activeInsight === "Persona" || activeInsight === "Influence") && (
									<div className={styles.GraphContainer}>
										<div className={styles.GraphHeader}>
											<h1>120K</h1>
											<h4>
												{activeInsight === "Persona" ? "Persona reached" : "Influence"}
											</h4>
										</div>
										<Chart data={chartData} />
									</div>
								)
							}

							{
								activeInsight === "PersonaViews" && (
									<div className={styles.AudienceInsightsRight}>
										<div className={styles.AudienceInsightsTop}>
											<h5>
												Audience Base
												<p>Take a deep look on your audience</p>
											</h5>
										</div>

										<div className={styles.AudienceInsightsBottom}>
											<div className={styles.AudienceBottomLeftRight}>
												<p>Location</p>

												<div className={styles.bottomGroup}>
													<div>
														<p>USA</p>
														<p>14%</p>
													</div>
													<span>
														<p style={{ width: "14%" }}></p>
													</span>
												</div>

												<div className={styles.bottomGroup}>
													<div>
														<p>India</p>
														<p>84%</p>
													</div>
													<span>
														<p style={{ width: "84%" }}></p>
													</span>
												</div>

												<div className={styles.bottomGroup}>
													<div>
														<p>Australia</p>
														<p>14%</p>
													</div>
													<span>
														<p style={{ width: "14%" }}></p>
													</span>
												</div>

												<button>View All</button>
											</div>

											<div className={styles.AudienceBottomLeftRight}>
												<p>Age</p>
												<div className={styles.bottomGroup}>
													<div>
														<p>Male</p>
														<p>14%</p>
													</div>
													<span>
														<p style={{ width: "14%" }}></p>
													</span>
												</div>
												<div className={styles.bottomGroup}>
													<div>
														<p>Female</p>
														<p>44%</p>
													</div>
													<span>
														<p style={{ width: "44%" }}></p>
													</span>
												</div>
												<button>View All</button>
											</div>
										</div>
									</div>
								)
							}



							{/* <div className={`${styles.AudienceInsights} ${styles.ProfileVisit}`}>
								<div className={styles.AudienceInsightsLeft}>
									<img src={Background3} alt="" />
								</div>
								<div className={styles.AudienceInsightsRight}>
									<div className={styles.AudienceInsightsTop}>
										<h5>
											Audience Base
											<p>Take a deep look on your audience</p>
										</h5>
									</div>

									<div className={styles.AudienceInsightsBottom}>
										<div className={styles.AudienceBottomLeftRight}>
											<p>Location</p>

											<div className={styles.bottomGroup}>
												<div>
													<p>USA</p>
													<p>14%</p>
												</div>
												<span>
													<p style={{ width: "14%" }}></p>
												</span>
											</div>

											<div className={styles.bottomGroup}>
												<div>
													<p>India</p>
													<p>84%</p>
												</div>
												<span>
													<p style={{ width: "84%" }}></p>
												</span>
											</div>

											<div className={styles.bottomGroup}>
												<div>
													<p>Australia</p>
													<p>14%</p>
												</div>
												<span>
													<p style={{ width: "14%" }}></p>
												</span>
											</div>

											<button>View All</button>
										</div>

										<div className={styles.AudienceBottomLeftRight}>
											<p>Age</p>
											<div className={styles.bottomGroup}>
												<div>
													<p>Male</p>
													<p>14%</p>
												</div>
												<span>
													<p style={{ width: "14%" }}></p>
												</span>
											</div>
											<div className={styles.bottomGroup}>
												<div>
													<p>Female</p>
													<p>44%</p>
												</div>
												<span>
													<p style={{ width: "44%" }}></p>
												</span>
											</div>
											<button>View All</button>
										</div>
									</div>
								</div>
							</div> */}
						</div>
						{/* <div className={styles.InsightsLeft}>
							<h1>Profile Insights</h1>
							<h4>Take a deep look at how your account and content are performing</h4>
							<div className={styles.GraphContainer}>
								<Chart data={data} />
							</div>
						</div> */}

						{/* <div className={styles.InsightsRight}>
							<select>
								<option value="1">1</option>
								<option value="2">2</option>
								<option value="3">3</option>
								<option value="4">4</option>
								<option value="5">5</option>
								<option value="6">6</option>
								<option value="7">7</option>
								<option value="8">8</option>
								<option value="9">9</option>
								<option value="10">10</option>
							</select>

							<div className={styles.InsightsBoxContainer}>
								<div className={`${styles.InsightsBox} ${styles.active}`}>
									<h1>120K</h1>
									<p>Persona reached</p>
								</div>
								<div className={styles.InsightsBox}>
									<h1>12K</h1>
									<p>Influence</p>
								</div>
								<div className={styles.InsightsBox}>
									<h1>120K</h1>
									<p>Persona Views</p>
								</div>
								<div className={styles.InsightsBox}>
									<h1>12K</h1>
									<p>Influence</p>
								</div>
								<div className={styles.InsightsBox}>
									<h1>120K</h1>
									<p>Persona Views</p>
								</div>
							</div>
						</div> */}
					</div>
				</div>
			</div>
		</div>
	);
};

export default PersonalInsights;


